
import axios from "axios";
import { headers_get } from "../tokens/get_headers_user";

//Este método tiene como objetivo proporcionar el número 
//total de datos a consultar basándonos en el paginado solicitado.
export async function numberData(url, parameters) {
  console.log(parameters)
  const headers = await headers_get();

  //Se recibe como parámetro una variable url
  try {
    //Se ejecuta una peticion get y se guarda como promesa la respuesta
    const response = await axios.get(`${url}`, {
      params: parameters,
      headers: headers,
    });
    const data = response.data.count;
    return data;//Se retorna la respuesta en caso de éxito
  } catch (error) {
    console.error(error);
    return null; //Se retorna un null en caso de fallo
  }
}







